import React from "react";

const OurStory = () => {
  const timeline = [
    {
      year: "2018",
      title: "Lancement d’IrokoFabLab",
      description:
        "Un lieu à Cotonou pour découvrir la fabrication numérique et expérimenter avec les machines et outils modernes."
    },
    {
      year: "2020",
      title: "Premiers stages & bootcamps",
      description:
        "Des dizaines de jeunes découvrent la robotique, le design et la programmation grâce à nos programmes immersifs."
    },
    {
      year: "2023",
      title: "Naissance de NextMaker",
      description:
        "L’idée de créer une plateforme d’apprentissage pour Maker accessible à tous en Afrique voit le jour."
    },
    {
      year: "2025",
      title: "Lancement officiel",
      description:
        "NextMaker devient le premier écosystème panafricain d’apprentissage hybride dédié aux makers."
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-light-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Titre */}
        <h2 className="text-title font-bold text-dark-1 text-center mb-12">
          Notre Histoire
        </h2>

        {/* Timeline */}
        <div className="relative border-l-4 border-primary pl-8 space-y-12">
          {timeline.map((item, index) => (
            <div key={index} className="relative">
              {/* Point sur la ligne */}
              <span className="absolute -left-[22px] flex items-center justify-center w-10 h-10
              bg-primary text-red-4 font-bold rounded-full shadow-md">
                {item.year}
              </span>

              {/* Contenu */}
              <div className="bg-white rounded-2xl shadow-lg p-6">
                <h3 className="text-subtitle font-semibold text-dark-1 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-normal">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurStory;
